import { contactPageWidgets } from '~/config/widgets/contactPageWidgets';
import { AppRoute } from '@agentselly/immodossier-shared';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_$CONTACTID_CONTACT,
  contactPageWidgets,
);
